import { apiClient } from './client';

export interface RowError {
  sheet: string;
  row: number;
  field?: string;
  message: string;
}

export interface BatchImportSummary {
  ranchos: { toCreate: number; created: number };
  lotes: { toCreate: number; created: number };
  usuarios: { toCreate: number; created: number };
  catalogo: { toCreate: number; created: number };
}

export interface BatchImportResponse {
  dryRun: boolean;
  errors: RowError[];
  summary: BatchImportSummary;
  preview?: {
    ranchos: Array<{ _row: number; name: string; ubicacion?: string; hectareas?: number }>;
    lotes: Array<{ _row: number; ranchoName: string; name: string; cropType?: string; hectares?: number }>;
    usuarios: Array<{ _row: number; phoneNumber: string; name: string; roles: string[] }>;
    catalogo: Array<{ _row: number; name: string; category: string; unit: string; unitCost: number }>;
  };
}

function fileToBase64(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const result = reader.result as string;
      resolve(result.split(',')[1] ?? '');
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}

async function runBatchImport(file: File, dryRun: boolean): Promise<BatchImportResponse> {
  const fileBase64 = await fileToBase64(file);
  const { data } = await apiClient.post<BatchImportResponse>('/api/batch-import', { fileBase64, dryRun });
  return data;
}

export const previewBatchImport = (file: File) => runBatchImport(file, true);
export const commitBatchImport  = (file: File) => runBatchImport(file, false);
